import axios from 'axios';
import addresstypes from './addresstypes';
import contacts from './contacts';
import _, { indexOf } from 'lodash'
import companyTypes from './company-types';
import beneficialAccounts from './beneficial-accounts';
import { useTablePreferenceStore } from '../../pinia/TablePreferenceStore';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list: [],
    companies: [],
    take: 25,
    skip: 0,
    loading: false,
    allLoaded: false,
    addNew: false,
    editCompany : false,
    columns: [
        {
            table: "companies",
            key: "name",
            label: "name",
            display: true,
            direction : "ASC",
            direction_pos : 0,
        },
        {
            table: "companies",
            key: "short_name",
            label: "short_name",
            display: true,
            direction : "ASC",
            direction_pos: 0,
        },
    ],
    filter: {},
    workingOn: [],
    isSaving: false,
    infinity: {
        active: false,
        clear: false,
        search: "",
        columns: ['name', 'short_name', "quick_note"],
        allLoaded: false,
        loading: false,
        loadingMore: false,
        take: 50,
    },
    relationTypes: [],
    defaults: {
        footer: [{ "lines": [{ "style": [], "text": "" }, { "style": [], "text": "" }, { "style": [], "text": "" }, { "style": [], "text": "" }, { "style": [], "text": "" }] }, { "lines": [{ "style": [], "text": "" }, { "style": [], "text": "" }, { "style": [], "text": "" }, { "style": [], "text": "" }, { "style": [], "text": "" }] }, { "lines": [{ "style": [], "text": "" }, { "style": [], "text": "" }, { "style": [], "text": "" }, { "style": [], "text": "" }, { "style": [], "text": "" }] }],
        zugferd: { version: "xrechnung_2_2", fiscalcode: "", vat : ""},
        edi: { version: "none", deliverTo: "", deliverBuyersCode: "", invoiceTo: "" },
    },
    pagination: {
        currentPage: 1,
        totalPageCount: 1,
    },
    meat: {},
    wkv : {
        open: 0,
        used : 0,
        limit : 0,
    },
    import : null,
})

// getters
const getters = {
    company: (state) => (id) => {
        return state.companies[state.companies.findIndex(item => item.id == id)]
    },
    getWithType: (state) => (type) => {
        return state.companies.filter(item => item.companyTypes.length > 0 && item.companyTypes.includes(type));
    },
    getCompanyById: (state) => (id) => {
        return state.companies[state.companies.findIndex(item => item.id == id)]
    }
}

// actions
const actions = {
    async update({ commit, state, rootState }, data) {
        commit("workingOn", data.company.id);
        commit("isSaving", true);
        return await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/companies/" + data.company.id, data).then(response => {
            commit("update", response.data.data);
            commit("doneWorkingOn", data.id);
            commit("isSaving", false);
            return response.data.data;
        })
    },
    async store({ commit, state, rootState }, data) {
        commit("isSaving", true);
        return await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/companies", data).then((response) => {
            commit("store", response.data.data);
            commit("isSaving", false);
            return response.data.data;
        })
        commit("isSaving", false);
    },
    // Original list, still used for dropdown searches
    async load({ commit, state, rootState }, page = 1) {
        if (state.infinity.clear == true) {
            commit("infinityClear");
        }
        if (state.allLoaded == false && state.loading == false) {
            commit("isLoading", true);
                if(state.infinity.active == true){
                    commit("skip", state.companies.length);
                }else{
                    commit("skip", (page - 1) * state.take);
                }
                var skip = state.skip;
            await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/companies", { params: { search: state.infinity.search, take: state.take, skip: state.skip, columns: state.infinity.columns, filter: state.filter, table_columns: state.columns } }).then((response) => {
                commit("setCompanies", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
                commit("isLoading", false);
            });
            commit("isLoading", false);
        }
    },
    // New Companies table with table columns
    async load_list({ commit, state, rootState }, page = 1) {
        if (state.infinity.clear == true) {
            commit("infinityClear");
        }
        if (state.allLoaded == false && state.loading == false) {
            commit("isLoading", true);
                if(state.infinity.active == true){
                    commit("skip", state.companies.length);
                }else{
                    commit("skip", (page - 1) * state.take);
                }
                const tablePreferenceStore = useTablePreferenceStore();
                let columns = tablePreferenceStore.getColumnsForIdent('companies');

                await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/companies", {
                search: state.infinity.search,
                 take: state.take,
                  skip: state.skip,
                 columns: columns,
                 filter: state.filter
                }).then((response) => {
                commit("setCompanies", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
                commit("isLoading", false);
            });
            commit("isLoading", false);
        }
    },
    async delete({commit, state, rootState}, data) {
        if (data.data.url !== undefined && data.data.ids.length > 0) {
            for (var i = 0; i < data.data.ids.length; i++) {
                var url = data.data.url + "/" + data.data.ids[i];
                await axios.delete(url).then(response => {
                    commit("deleteCompany", data.data.ids[i]);
                }).catch(error => {
                   console.log(error.response.data.message);
                });
            }
        }
    },
    async getWkvLimit({ commit, state, rootState }, data){
        commit("setWkvLimit", { open: 0, used : 0, limit : 0});
        return await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/companies/" + data.company_id + "/wkv_limit", { params : {ignoreOrders: data.ignore} }).then(response => {
          return response.data;
          })
    },
}

// mutations
const mutations = {
    setWkvLimit(state, wkv){
        state.wkv = wkv;
    },
    clean(state) {
        state.list = [];
        state.companies = [];
        state.infinity.allLoaded = false;
        state.workingOn = [];
        state.filter = {};
    },
    pagination(state, object) {
        state.meta = object;
        if (state.skip <= 0) {
            state.pagination.currentPage = 1;
        } else {
            state.pagination.currentPage = (state.skip / state.take) + 1;
        }
        state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
        state.pagination.total = state.meta.total
        state.pagination.pagesize = state.meta.take

        if(state.infinity.active == true && state.meta.total <= state.skip){
            state.allLoaded = true;
        }
    },
    setTake(state, take){
        state.take = take;
    },
    skip(state, skip) {
        state.skip = skip;
    },
    isLoading(state, status) {
        state.loadingMore = status;
        state.loading = status;
    },
    setInfinityActive(state, active) {
        state.infinity.active = active;
    },
    infinityClear(state){
        state.skip = 0;
        state.allLoaded = false;
        state.companies = [];
    },
    addCompany(state, load) {
        state.addNew = load;
    },
    editCompany(state, id) {
        if(id === false){
            state.editCompany = false;
        }else{
            state.editCompany = id;
        }
    },
    update(state, company) {
        var index = state.companies.findIndex(item => item.id == company.id)
        if (index >= 0) {
            state.companies[index] = company;
        }
    },
    store(state, company) {
        state.companies.unshift(company);
    },
    setCompanies(state, companies) {
        if (state.infinity.clear == true) {
            state.companies = [];
            state.allLoaded = false;
        }
        if (state.infinity.active) {
            state.companies.push(...companies);
        } else {
            state.companies = companies;
        }

        state.infinity.clear = false;
    },
    isSaving(state, status) {
        state.isSaving = status;
    },
    workingOn(state, id) {
        if (state.workingOn.findIndex(item => item == id) < 0) {
            state.workingOn.push(id);
        }
    },
    doneWorkingOn(state, id) {
        var index = state.workingOn.findIndex(item => item == id);
        if (index >= 0) {
            state.workingOn.splice(index, 1);
        }
    },
    setSearch(state, search) {
        state.infinity.loading = true;
        state.infinity.allLoaded = false;
        state.infinity.search = search;
        state.infinity.clear = true;
    },
    setSearchValue(state, value) {
        state.infinity.search = value;
    },
    setRelationTypes(state, data) {
        state.relationTypes = data;
    },
    setFilter(state, type) {
        state.filter = Object.assign(state.filter, type);
    },
    removeFilter(state, type) {
        delete (state.filter[type]);
    },
    deleteCompany(state, id) {
        var index = state.companies.findIndex(item => item.id == id);
        if (index >= 0) {
            state.companies.splice(index, 1);
        }
    },
    updateColumn(state, column){
        var index = state.columns.findIndex(item => item.key == column.key)
        for(let i in state.columns){
            state.columns[i].direction_pos += 1;
        }
        if(index > -1){
            column.direction_pos = 0;
            state.columns[index] = column;
        }
    },
    setImport(state, data){
        state.import = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        addresstypes,
        contacts,
        companyTypes,
        beneficialAccounts,
    }
}
